import { render } from "./TheAdminVideoDestroy.vue?vue&type=template&id=37f4311c&ts=true"
import script from "./TheAdminVideoDestroy.vue?vue&type=script&lang=ts"
export * from "./TheAdminVideoDestroy.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__